import { readonly } from 'vue';

export type value = null | string | boolean;

export type originState = {
  originalValue: value;
  keyInherited: boolean | undefined;
};

export type item = {
  keyInherited?: boolean;
  value: value;
  originState?: originState;
};

export function inheritanceHandler(item: item) {
  if (item.originState === undefined) {
    item.originState = readonly({
      originalValue: item.value,
      keyInherited: item.keyInherited,
    });
  }

  const { originState, value: newValue } = item;
  if (!originState)
    throw new Error('inheritanceHandler: originState is undefined');

  const valueMatch = originState.originalValue === newValue;

  if (valueMatch) {
    if (originState.keyInherited === undefined) {
      delete item.keyInherited;
    } else {
      item.keyInherited = originState.keyInherited;
    }
  } else {
    item.keyInherited = false;
  }
}
